<template>
    <v-sheet>
        <v-toolbar color="orange" dark dense flat>
            <v-toolbar-title>Padecimientos INSABI</v-toolbar-title>
        </v-toolbar>
        <v-row>
            <v-col cols=3>
                <v-treeview
                    :active.sync="activo"
                    :items="items"
                    item-text="text"
                    item-key="id"
                    item-disabled="disabled"
                    :open-on-click="true"
                    shaped
                    hoverable
                    activatable
                    dense
                    return-object
                />
        </v-col>
            <v-col cols=9>
                <v-alert v-if="!(estePad && estePad.id)" type="warning" text class="ma-5">
                    Seleccione un diagnóstico
                </v-alert>

                <transition
                    name="fade"
                    mode="out-in"
                >

                <div v-if="(estePad && estePad.id)">
                    <div class="text-h5">{{estePad?estePad.grupo:''}}</div>
                    <div class="text-h6">{{estePad?estePad.text:''}}</div>

                    <v-sheet elevation="2">
                        <v-tabs v-model="tab" color="orange" slider-size="5">
                            <v-tab>CIE-10</v-tab>
                            <v-tab>Medicamentos y material</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <v-tab-item>
                                <cie10
                                    :diag="estePad.id"
                                />
                            </v-tab-item>
                            <v-tab-item>
                                <medicamento
                                    :diag="estePad.id"
                                />
                            </v-tab-item>
                        </v-tabs-items>


                    </v-sheet>
                </div>
                </transition>
            </v-col>
        </v-row>

    </v-sheet>
</template>

<script>
export default {
    mounted(){
        this.cargaList()
    },
    components:{
        'cie10':()=>import('@/components/admin/catalogos/insabi/InsabiCie10'),
        'medicamento':()=>import('@/components/admin/catalogos/insabi/InsabiMedicamentos'),
    },
    data:()=>({
        items:[],
        activo:[],
        estePad:{},

        tab:0,
    }),
    methods:{
        async cargaList(){
            try{
                const req = await this.$http({
                    url:'/insabi/listPad',
                    method:'GET',
                })
                this.items=req.data
            }catch(err){
                this.$store.dispatch('security/revisaError',err)
            }
        }
    },
    computed:{
        
    },
    watch:{
        activo(v){
            if (v){
                this.estePad=v[0]
            } else {
                this.estePad={}
            }
        }
    },
}
</script>

<style>

</style>